<script setup lang="ts">
import { computed, ref } from 'vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    default: '',
  },
  error: {
    type: [String, Boolean],
    default: false,
  },
  nonFocusable: {
    type: Boolean,
    default: false,
  },
  partiallyChecked: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);

const model = defineModel({
  type: Boolean,
  default: false,
});

const inputFocused = ref(false);

const attrs = computed(() => ({
  tabindex: props.nonFocusable ? '-1' : undefined,
}));

const borderClass = computed(() => {
  if (props.disabled) return 'border-checkbox-border-disabled';
  if (props.error) return 'border-checkbox-border-error';
  if (inputFocused.value) return 'border-checkbox-border-hover';

  if (model.value || props.partiallyChecked) return 'border-checkbox-border-hover';

  return 'border-checkbox-border-idle hover:border-checkbox-border-hover';
});

const bgClass = computed(() => {
  if (props.disabled) return 'bg-checkbox-bg-disabled';
  if (props.error) return 'bg-checkbox-bg-error';

  if (model.value || props.partiallyChecked) return 'bg-checkbox-bg-checked';

  return 'bg-checkbox-bg-idle hover:bg-checkbox-bg-hover';
});
</script>

<template>
  <div
    class="
      h-5 w-5 rounded-md border-2 text-input
      flex items-center cursor-pointer flex justify-center items-center
    "
    :class="[
      borderClass,
      bgClass,
      disabled ? 'cursor-not-allowed' : '',
    ]"
    tabindex="-1"
    @click="$emit('click', $event); model = !model"
  >
    <input
      :id="id || name"
      v-model="model"
      v-bind="attrs"
      type="checkbox"
      :name="name"
      class="w-0 h-0 outline-none opacity-0"
      @focus="inputFocused = true"
      @blur="inputFocused = false"
    >
    <Icon v-if="model" name="ic:baseline-check" class="w-4 h-4 c-text-white" />
    <Icon v-if="partiallyChecked && !model" name="ic:round-minus" class="w-4 h-4 c-text-white" />
  </div>
</template>
